import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../components";

const JurisdictionConflictModal = props => {
	const { lang } = global;
	const { show, modalMessage, onCancel, onConfirm } = props;

	return (
		<Modal
			show={show}
			onHide={onCancel}
		>
			<Modal.Header>
				<Modal.Title>{`${lang.t("Move")} ${lang.t("Jurisdiction")}`}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center">{modalMessage}</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={onCancel}
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onConfirm}
				>
					{`${lang.t("Move")} ${lang.t("Officers")}`}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

JurisdictionConflictModal.propTypes = {
	show: PropTypes.bool,
	modalMessage: PropTypes.any,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
};

JurisdictionConflictModal.defaultProps = {
	show: false,
	modalMessage: "",
	onCancel: () => {},
	onConfirm: () => {},
};

export default JurisdictionConflictModal;
